import type { Theme } from "@mui/material"
import { CalcInputButtonTheme } from "core/themes/src/definitions/components.types"

export const createCalcInputButtonTheme = (theme: Theme): CalcInputButtonTheme => ({
    styleOverrides: {
        root: {
            "&.btn-overrides": {
                padding: "0.4em",
                "line-height": "1rem",
            },
        },
        replace: {
            "&.btn-overrides": {
                padding: "0.4em",
                "line-height": "1rem",
            },
        },
    },
})
